var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeBtwCeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4456 73.1258C80.4089 80.6322 74.8633 86.8535 67.7539 90.7296C60.6444 94.6057 52.411 95.8968 44.4563 94.3829C36.5017 92.869 29.318 88.6437 24.1294 82.4271C18.9408 76.2104 16.0682 68.387 16.0012 60.2899C15.9342 52.1927 18.6768 44.3228 23.7617 38.0211C28.8467 31.7193 35.9593 27.3757 43.8878 25.7303C51.8163 24.0848 60.0701 25.2394 67.2427 28.9973C74.4154 32.7551 80.0632 38.8837 83.2238 46.3388",
    stroke: "#128370",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 37V65.9655L67 79",
    stroke: "#128370",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 55H104M79.5 61.5H90",
    stroke: "#128370",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBtwCeb);
export default __webpack_public_path__ + "static/media/time_btw_ceb.29b677381176c04327364441dfe8e7bc.svg";
export { ForwardRef as ReactComponent };